import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, ArrowUpRight } from 'lucide-react';
import BLOG_ARTICLES from '../data/blogArticles';
import { Container, SectionHeader, Reveal } from './landing/primitives';

const fmt = (d) => new Date(d).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });

const BlogTeaser = () => {
  const articles = BLOG_ARTICLES.slice(0, 3);
  return (
    <section className="py-24 lg:py-32 border-t border-line bg-app-alt" data-testid="blog-teaser-section">
      <Container>
        <SectionHeader
          eyebrow="Journal"
          title="Latest thinking."
          action={
            <Link to="/blog" className="inline-flex items-center gap-2 text-sm text-content hover:gap-3 transition-[gap] duration-300" data-testid="view-all-blog">
              View all articles <ArrowRight className="w-4 h-4" />
            </Link>
          }
        />
        <Reveal delay={0.1} className="mt-14">
          {articles.map((a, idx) => (
            <Link
              key={a.slug}
              to={`/blog/${a.slug}`}
              className="group grid md:grid-cols-12 gap-3 md:gap-8 py-8 border-t border-line last:border-b hover:border-line-2 transition-colors duration-300"
              data-testid={`blog-teaser-${idx}`}
            >
              <div className="md:col-span-3 flex md:flex-col gap-3 md:gap-1 text-[11px] font-mono text-content-3">
                <span className="uppercase tracking-[0.18em]">{a.category}</span>
                <span>{fmt(a.date)} · {a.readTime}</span>
              </div>
              <div className="md:col-span-8">
                <h3 className="text-xl lg:text-2xl font-heading font-medium tracking-tight text-content leading-snug group-hover:text-content-2 transition-colors duration-300">
                  {a.title}
                </h3>
                <p className="mt-3 text-content-2 text-sm leading-relaxed line-clamp-2 max-w-2xl">{a.excerpt}</p>
              </div>
              <div className="md:col-span-1 flex md:justify-end">
                <ArrowUpRight className="w-5 h-5 text-content-3 group-hover:text-content group-hover:-translate-y-0.5 group-hover:translate-x-0.5 transition-[color,transform] duration-300" strokeWidth={1.5} />
              </div>
            </Link>
          ))}
        </Reveal>
      </Container>
    </section>
  );
};

export default BlogTeaser;
